<script>
	import { convertToCamelCase, slugify } from "cando-util";
	import { deleteDoc, doc, getFirestore } from "firebase/firestore";
	import { goto } from "$app/navigation";

	export let obj = {};
	export let colDtls;
	export let btnCls =
		"w-full btn btn-warning my-2 sm:my-4 rounded-btn modal-button";
	export let redirectLink = false;
	export let disabled = false;
	export let deleteFunction = false;
	export let closeModalOnDelete = false;

	const { name, singular } = colDtls;
	const colType = singular.toLowerCase();
	// const col = name.toLowerCase();
	const col = colDtls.col || convertToCamelCase(name);

	const deleteObj = async (e) => {
		const docId = e.target.getAttribute("docId");

		const delElem = document.getElementById(
			docId + "-closeDeleteModalCancel",
		);
		delElem && delElem.click();
		const elem = document.getElementById(docId + "-closeModalCancel");
		elem && elem.click();

		if (deleteFunction) {
			await deleteFunction(e);
		} else {
			await deleteDoc(doc(getFirestore(), col, docId));
		}

		if (!closeModalOnDelete) {
			if (redirectLink) {
				goto(redirectLink);
			} else {
				goto(`/${col}`);
			}
		} else {
			const modal = document.getElementById(
				`${slugify(obj.id || obj.docId)}-deleteModal`,
			);
			if (modal) modal.checked = false;
		}
	};

	let deleteWarning = `Deleting the ${colType} will remove all the data and media content that 
		has been added. This can not be undone.`;

	if (colType === "subscription") {
		deleteWarning = `
			Deleting the ${colType} will instantly remove access for the email address associated
			with it.  This can not be undone.
		`;
	}
</script>

<label
	id={`${slugify(obj.id || obj.docId)}-delete-modal-label`}
	for={`${slugify(obj.id || obj.docId)}-deleteModal`}
	class={`${btnCls} ${disabled ? " btn-disabled" : ""}`}
	>Delete {singular}</label
>
{#if !disabled}
	<input
		type="checkbox"
		id={`${slugify(obj.id || obj.docId)}-deleteModal`}
		class="modal-toggle"
	/>
	<div class="modal modal-bottom sm:modal-middle">
		<div class="modal-box">
			<h3 class="text-lg font-bold sm:text-2xl">
				Delete {singular}: {obj.name}
			</h3>
			<p class="py-2 sm:py-4">
				Are you sure you want to delete this {colType}?
			</p>
			<p class="py-2 sm:py-4">
				{deleteWarning}
			</p>
			<button
				id={`${slugify(obj.id || obj.docId)}-delete-object-button`}
				docId={obj.docId}
				class="my-5 btn btn-sm btn-error sm:my-10 rounded-btn"
				on:click|preventDefault={deleteObj}>Delete {singular}</button
			>
			<div class="modal-action">
				<label
					id={`${slugify(obj.id || obj.docId)}-closeDeleteModalCancel`}
					for={`${slugify(obj.id || obj.docId)}-deleteModal`}
					class="btn">Cancel</label
				>
			</div>
		</div>
	</div>
{/if}
